import { isString } from 'lodash';

export const isValidEvmAddress = (address: string | null): boolean => {
  if (!isString(address)) {
    return false;
  }
  const match = address.match(/^0x[a-f0-9]{40}$/i);
  return !!match;
};
